import { Suspense } from "react";
import RegisterPage from "@/app/auth/register/register";
import AuthSkeleton from "@/components/auth-skeleton";

export default function AuthRegisterPage() {
  return (
    <Suspense fallback={<AuthSkeleton />}>
      <RegisterPage />
    </Suspense>
  )
}
